// extracted by mini-css-extract-plugin
export var modal = "_ho-0";